module.exports = __webpack_public_path__ + "img/arrow-down.7ff9ca73.svg";